<template>
  <Event />
</template>

<script>
import Event from '@/components/content/events/EditSelectedEvent.vue'

export default {
  name: 'ClassEvent',
  components: { Event }
}
</script>

<style scoped>

</style>
